import { render } from "./NewItemButtons.vue?vue&type=template&id=bfb1d448"
import script from "./NewItemButtons.vue?vue&type=script&lang=js"
export * from "./NewItemButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__